import type { SlateEditor } from '@udecode/plate';

import { BaseCitationPlugin } from '../BaseCitationPlugin';
import type { TCitationElement } from '../types';

export function getCurrentCitationElement(editor: SlateEditor): TCitationElement | null {
    const at = editor.selection;

    if (!at){
        return null;
    }

    const currentElement = editor.api.block({
        at,
        match: { type: editor.getType(BaseCitationPlugin) },
    });

    return currentElement ? (currentElement[0] as TCitationElement) : null;
}
